"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.IntermediateRecordConfigSchema = exports.nodeType = exports.UIConfigSchema = exports.ForwardConfigSchema = exports.SftpForwardConfigSchema = exports.SftpOutputConfigSchema = void 0;
const zod_1 = require("zod");
const finley_types_1 = require("@finley-technologies/finley-types");
// every node must export UIConfig.
// this type describes the configuration
// for the node as seen on tape-builder UI.
// there must also be a json schema associated with it.
exports.SftpOutputConfigSchema = zod_1.z.object({
    inputArtifactSlug: zod_1.z
        .string()
        .describe('Input artifact slug for this output configuration.'),
    path: zod_1.z
        .string()
        .optional()
        .describe('Defaults to "/" if undefined. If defined, should not end in trailing "/".'),
    baseFilename: zod_1.z.string().describe('Base filename of the uploaded file'),
    ext: zod_1.z.enum(['csv', 'json']).describe('Extension of the uploaded file'),
    skipProcessing: zod_1.z
        .boolean()
        .optional()
        .describe('Skip processing within Finley servers. This option directly streams the file from the source to destination'),
});
exports.SftpForwardConfigSchema = zod_1.z.object({
    type: zod_1.z.literal('sftp'),
    // @makarand-zod: review
    sftpConnection: finley_types_1.Util.SftpConfigSchema.describe('Configuration to connect to external sftp (Util.SftpConfig)'),
    outputs: zod_1.z
        .array(exports.SftpOutputConfigSchema)
        .describe('Configuration for sftp upload path, filename, and extension.'),
});
exports.ForwardConfigSchema = exports.SftpForwardConfigSchema;
exports.UIConfigSchema = zod_1.z.object({
    artifactSlug: zod_1.z.string().describe('Artifact slug'),
    config: exports.ForwardConfigSchema.describe('Forward Configuration'),
});
exports.nodeType = 'file_forwardedTape';
// every tape node must also export IntermediateRecordConfig.
// this type describes the configuration for the IntermediateRecord
// (type generated by converting UI Tape + Operation Node config ).
// this includes the config for the preceding operation + config for the Tape
// + any synthetic/generated config that is needed for the corresponding task.
// - any fields that are not part of config but are part of top level record.
exports.IntermediateRecordConfigSchema = exports.UIConfigSchema.omit({
    artifactSlug: true,
});
// every tape node must also export IntermediateRecord.
// it describes the record that will be inserted into the database. (well not completely,
// because it may be modified by synthetic node creation later)
// it includes IntermediateRecordConfig + top level field like type, externalFilename, loanProductSlug, creditFacilitySlug etc.
exports.artifactType = 'forwardedTape';
//# sourceMappingURL=types.js.map